export const bars = {
	title: "Bars",
	description:
		"Select the bars where your product will be active. Operators linked to these bars will have this product available for consumption.",
	actions: {
		linkBars: "Add to bars",
		unlinkBars: "Unlink bar",
		linkBar: "Link bar",
		unlinkBar: "Unlink bar",
		next: "Next",
		back: "Back",
	},
	notifications: {
		success: "Product successfully linked to the selected bars.",
		error: "Some links failed. Please try again later.",
		genericError: "Error linking product to bars. Please try again later.",
		unlinkSuccess: "Product successfully unlinked from the bar.",
		genericUnlinkError: "Error unlinking product from the bar. Please try again later.",
	},
	unlinkBarsConfirmation: {
		title: "Unlink bar",
		message:
			"Do you want to remove the link with this bar? If so, your product will no longer be available for consumption at the bar.",
		confirm: "Unlink bar",
		cancel: "Cancel",
	},
	labels: {
		linkedBars: "Linked bars",
		optional: "Optional",
		selectBars: "Choose the bars where your product will be active.",
		stock: "Stock",
		ip: "Printer IP",
	},
	fields: {
		searchLabel: "Available bars",
		searchPlaceholder: "Search for a bar",
	},
	emptyState: {
		title: "No linked bars yet",
		description: "Add bars to make this product available for consumption there.",
	},
};
